<template>
  <div class="materials-popular">
    <h2>популярные материалы</h2>

    <template v-for="(material, index) in materials">
      <materials-item-check-list
        v-if="index === 2"
        :key="index"
      />
      <materials-item
        :key="material.id"
        :material="material"
      />
    </template>

    <div class="materials-popular__show-more">
      <button
        class="m-btn"
        @click="showMore"
      >
        показать еще 4 статьи
      </button>
    </div>
  </div>
</template>

<script>
import MaterialsItem from './MaterialsItem.vue';
import MaterialsItemCheckList from './MaterialsItemCheckList.vue';

export default {
  name: 'MaterialsPopular',
  components: { MaterialsItemCheckList, MaterialsItem },
  data: () => ({
    uploadedMaterials: [],
    pagination: {},
    showedMaterials: 7,
  }),
  async fetch() {
    await this.fetchMaterials();
  },
  computed: {
    materials() {
      if (this.showedMaterials < this.uploadedMaterials.length) {
        return this.uploadedMaterials.slice(0, this.showedMaterials);
      }

      return this.uploadedMaterials.slice(0, this.showedMaterials - 4);
    },
  },
  methods: {
    async fetchMaterials() {
      const params = {
        page: (this.pagination.page || 0) + 1,
        perPage: 8,
        orderAttributes: { views_count: 'desc' },
        kind: 'article',
      };

      const { publicMaterials, ...pagination } = await this.$api.getMaterials(params);
      this.pagination = pagination;
      this.uploadedMaterials.push(...publicMaterials);
    },
    showMore() {
      this.showedMaterials += 4;
      this.fetchMaterials();
    },
  },
};
</script>

<style scoped lang="scss">

.materials-popular {
  display: flex;
  flex-wrap: wrap;
  gap: calc(var(--scale) * 80) calc(var(--scale) * 20);

  @include media-down($size-tablet) {
    gap: calc(var(--scale) * 40) calc(var(--scale) * 8);
  }

  h2 {
    width: 100%;
    margin-bottom: calc(-1 * var(--scale) * 40);

    font-weight: 500;
    font-size: calc(var(--scale) * 64);
    line-height: 95%;
    letter-spacing: -0.02em;
    color: #02120F;

    @include media-down($size-tablet) {
      margin-bottom: calc(-1 * var(--scale) * 16);
      font-size: calc(var(--scale) * 44);
      line-height: 90%;
      letter-spacing: -0.06em;
    }
  }

  .materials-item-check-list,
  .materials-item {
    height: auto;
    width: calc((100% / 4) - (calc(var(--scale) * 60) / 4));

    @include media-down($size-tablet) {
      width: calc((100% / 2) - var(--scale) * 4);
    }

    @include media-down($size-mobile) {
      width: 100%;
    }
  }

  &__show-more {
    width: 100%;
    display: flex;
    justify-content: center;

    @include media-up($size-tablet) {
      margin-top: calc(-1 * var(--scale) * 40);
    }

    button {
      padding: calc(var(--scale) * 44) calc(var(--scale) * 56);
      border: 1px solid #A7ABAC;
      border-radius: calc(var(--scale) * 40);

      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #02120F;

      @include media-down($size-tablet) {
        width: 100%;
        padding: calc(var(--scale) * 30) 0;
        border-radius: calc(var(--scale) * 24);
        font-size: calc(var(--scale) * 18);
      }
    }
  }
}

</style>
